import { createContext } from "react";
import { ConnectionState, DepositWithdrawDialogTab, ERC2612PermitMessage_RSV, IRPCError, ISystemSummaryObj, IWallet, defaultSystemSummary, defaultWallet } from "./types";
import { ContractManager, ITokenContract } from "../ABIs/contract_map";
import { ethers } from "ethers";
import { DEFAULT_STRATEGY_INDEX, IStrategy, strategies } from "../components/sidebar/elements/strategy-info.component";

// FCA compliance context
export type AcceptedFCAContextData = { acceptedFcaNotice?: boolean; };
export const AcceptedFCAContext = createContext<AcceptedFCAContextData>({ acceptedFcaNotice: undefined });

// Loader context
export type LoaderContextData = { isLoading: boolean; };
export const LoaderContext = createContext<LoaderContextData>({ isLoading: false });

// Wallet context
export type WalletContextData = { wallet: IWallet; };
export const WalletContext = createContext<WalletContextData>({ wallet: defaultWallet });

// Strategy context
export type StrategyContextData = { selectedStrategy: IStrategy; setStrategy: (selectedStrategy: IStrategy) => void; };
export const StrategyContext = createContext<StrategyContextData>({ selectedStrategy: strategies[DEFAULT_STRATEGY_INDEX], setStrategy: (a) => console.warn("setStrategy not bound") });

// Contracts context
export type ContractsManagerContextData = { contractManager: ContractManager; };
export const ContractsManagerContext = createContext<ContractsManagerContextData>({ contractManager: new ContractManager() });

// SystemSummary context
export type SystemSummaryContextData = { SystemSummary: ISystemSummaryObj; };
export const SystemSummaryContext = createContext<SystemSummaryContextData>({ SystemSummary: defaultSystemSummary });

// Functions context
export type OverlayType = "FAQ" | "WALLET-SELECTION" | null;
export type FunctionsContextData = {
	tryTx: (method: ethers.ContractFunction, params?: any[], value?: string) => Promise<void>;
	approve: (tokenContract: ITokenContract, addressToApprove: string, approvalAmount: ethers.BigNumberish) => void;
	createPermit: (tokenContract: ITokenContract, addressToApprove: string, approvalAmount: ethers.BigNumberish) => Promise<ERC2612PermitMessage_RSV>;
	showErrorMessage: (error: IRPCError) => void;
	showDialog: (title: string | JSX.Element, content: string | JSX.Element) => void;
	setActiveOverlay: (overlay: OverlayType) => void;
	toggleDepositWithdrawDialog: (tab: DepositWithdrawDialogTab) => void;
	switchDepositWithdrawDialogTab: (tab: DepositWithdrawDialogTab) => void;
	subscribeToBlockchain: (callback: (...args: any[]) => Promise<void> | void) => void;
	unsubscribeToBlockchain: (callback: (...args: any[]) => Promise<void> | void) => void;
	setWalletConnectionState: (connectionState: ConnectionState) => void;
	setLoader: (isLoading: boolean) => void;
};
export const FunctionsContext = createContext<FunctionsContextData>({
	tryTx: (a, b?, c?) => new Promise(() => console.warn("tryTx not bound")),
	approve: (a, b, c) => console.warn("approve not bound"),
	createPermit: (a, b, c) => new Promise(() => console.warn("createPermit not bound")),
	showErrorMessage: (a) => console.warn("showErrorMessage not bound"),
	showDialog: (a, b) => console.warn("showDialog not bound"),
	setActiveOverlay: (a) => console.warn("setActiveOverlay not bound"),
	toggleDepositWithdrawDialog: (a) => console.warn("toggleDepositWithdrawDialog not bound"),
	switchDepositWithdrawDialogTab: (a) => console.warn("toggleDepositWithdrawDialog not bound"),
	subscribeToBlockchain: (a) => console.warn("subscribeToBlockchain not bound"),
	unsubscribeToBlockchain: (a) => console.warn("unsubscribeToBlockchain not bound"),
	setWalletConnectionState: (a) => console.warn("setWalletConnectionState not bound"),
	setLoader: (a) => console.warn("setLoader not bound")
});
